import dayjs from 'dayjs';

import {
  allPostsQuery,
  allPostsAndDraftsDraftsQuery,
  singlePostQuery,
  singlePostQueryAsSlugOnly,
  tagQueryAsTitleOnly,
  tagQuery,
  authorQuery,
  authorQueryAsSlugOnly,
} from './sanity.queries';
import client from './sanity.api';
import {getArticleSlug} from './blog';
import {urlFor} from './sanity.image';

export const getBlogHomepagePosts = async () => {
  if (client) {
    let posts = await client.fetch(allPostsQuery);

    posts = posts.map(post => ({
      link: getArticleSlug(post.slug.current, post.publishedAt),
      date: dayjs(post.publishedAt).format('MMMM D, YYYY'),
      slug: post.slug.current,
      image: !post.mainImage?.asset?._ref ? null : urlFor(post.mainImage.asset._ref).url(),
      ...post,
    }));

    return posts || [];
  }

  return [];
};

export const getBlogHomepagePostsAndDrafts = async () => {
  if (client) {
    return (await client.fetch(allPostsAndDraftsDraftsQuery)) || [];
  }
  return [];
};

export const getSinglePost = async (slugWithoutDates: string) => {
  if (client) {
    return (await client.fetch(singlePostQuery, {slugWithoutDates})) || ({} as any);
  }
  return {} as any;
};

export const getSinglePostAsSlugOnly = async () => {
  if (client) {
    return (await client.fetch(singlePostQueryAsSlugOnly)) || [];
  }
  return [];
};

export const getTag = async (slug: string) => {
  if (client) {
    return (await client.fetch(tagQuery, {slug})) || ({} as any);
  }
  return {} as any;
};

export const getTagAsTitleOnly = async () => {
  if (client) {
    return (await client.fetch(tagQueryAsTitleOnly)) || [];
  }
  return [];
};

export const getAuthor = async (slug: string) => {
  if (client) {
    return (await client.fetch(authorQuery, {slug})) || ({} as any);
  }
  return {} as any;
};

export const getAuthorAsSlugOnly = async () => {
  if (client) {
    return (await client.fetch(authorQueryAsSlugOnly)) || [];
  }
  return [];
};
